/* @flow */

import React from 'react';
import { Segment, Message, Table } from 'semantic-ui-react';
import EventItem from './EventItem';
import type { MySpaceEvent } from '../types';

type Props = {
  events: Array<MySpaceEvent>,
  onDelete: (event: MySpaceEvent) => void,
};

const MySpaceEvents = ({ events, onDelete }: Props) => {
  const renderContents = () => {
    if (events && events.length > 0) {
      return (
        <Table basic="very" celled selectable>
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell width={5}>Titre</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" width={3}>
                Thématique
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" width={3}>
                Statut
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" width={5}>
                Date
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {events.map(e => (
              <EventItem key={e.id} event={e} onDelete={onDelete} />
            ))}
          </Table.Body>
        </Table>
      );
    }

    return <Message icon="info" header="Aucun évènement" />;
  };

  return <Segment attached="bottom">{renderContents()}</Segment>;
};

export default MySpaceEvents;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/MySpaceEvents.js